export const toBoolean = (source: boolean | number | undefined): boolean => {
  return Boolean(Number(source)) || false;
};
